import { type Database } from "@fitness-app/supabase";

import { type CalendlyEventPayload } from "../external/Calendly";

export type CalendarEventEntity = Database["public"]["Tables"]["calendar_event"]["Row"];

export interface Location {
  address: Address;
  comment: string;
  created: string;
  name: string;
}
export interface Address {
  country: string;
  locality: string;
  number: string;
  postalCode: string;
  street: string;
}

export enum CalendarEventType {
  PERSONAL_TRAINING = "personalTraining",
  ONLINE_TRAINING = "onlineTraining",
  TRAINING_PLAN = "trainingPlan",
  STATIONARY_CONSULTATIONS = "stationaryConsultations",
  ONLINE_CONSULTATIONS = "onlineConsultations",
  DIET = "diet",
  PRODUCT = "product",
  ONLINE_COOPERATION = "onlineCooperation",
  OTHER = "other",
}

export interface TrainerEvent {
  id: string;
  clientId: string;
  eventId?: string;
  description?: string;
  clientName: string;
  clientEmail?: string;
  cost?: {
    amount: number;
    currency: string;
  };
  created: Date;
  end: Date;
  eventType: CalendarEventType;
  location: Location | null;
  paymentRefId: string | null;
  start: Date;
  syncId: string;
  trainerId: string;
  trainerName: string;
}

export type Email = string;

export type SyncedAccounts = Record<
  Email,
  {
    syncedIds: string[];
  }
>;

export enum CalendarEventStatus {
  ACTIVE = "active",
  CANCELED = "canceled",
  NO_SHOW = "noShow",
  ATTENDED = "attended",
}

export type CalendarEvent = CalendarEventEntity & {
  type: CalendarEventType;
  eventData: CalendlyEventPayload;
  status: CalendarEventStatus;
};

export type ScheduleCalendarEvent = CalendarEvent;
